import React, { useEffect, useState } from "react";
import useAppState from "../../../StateMachine/useAppState";
import FullScreenError from "../../../FullScreenError/FullScreenError";
import FullScreenSpinner from "../../../FullScreenSpinner/FullScreenSpinner";
import { Col, Container, Row } from "react-bs4grid";
import { Form, Formik } from "formik";

import acceptInviteFormValidationSchema from "./acceptInviteFormValidationSchema";
import FormError from "../../../formiks/FormError/FormError";
import SubmitButton from "../../../formiks/SubmitButton/SubmitButton";
import TextField from "../../../formiks/TextField/TextField";

const AcceptInvite = () => {
  const account = useAppState("account");
  const router = useAppState("router");
  const [hasError, setError] = useState(false);
  const [isReady, setReady] = useState(false);
  const [userData, setUserData] = useState({});

  useEffect(() => {
    const { Email, Token } = router.getQueryString();
    account
      .getUserByToken(Token, Email)
      .then(({ data }) => {
        setUserData(data);
        setReady(true);
      })
      .catch(_ => {
        setError(true);
      });
  }, []);

  if (hasError === true) {
    return (
      <FullScreenError>
        Unfortunately it looks as though this invite has expired. Please try
        again in a few minutes, and contact the invitee if the problem persists.
      </FullScreenError>
    );
  }

  if (isReady === false) return <FullScreenSpinner />;

  return (
    <Container className="pt-32">
      <Row>
        <Col>
          <h1>
            Welcome {userData.firstName} {userData.lastName}
          </h1>
          <h2>You have been invited!</h2>
        </Col>
      </Row>
      <Row className="pt-32">
        <Col md={{ size: 5 }}>
          <Formik
            validationSchema={acceptInviteFormValidationSchema}
            initialValues={{
              email: userData.email, //
              password: ""
            }}
            onSubmit={(values, formikActions) => {
              const { Token } = router.getQueryString();
              account
                .patchUserByToken(Token, values)
                .then(() => {
                  account.login(values).then(_ => {
                    router.push("/");
                  });
                })
                .catch(error => {
                  formikActions.setStatus(error.response.data.errorMessage);
                  formikActions.setSubmitting(false);
                });
            }}
            render={({ errors, isSubmitting }) => {
              return (
                <Form>
                  <TextField
                    label="Your Email Address"
                    name="email"
                    type="email"
                    placeholder="Please type your email"
                  />

                  <TextField
                    label="Choose a password"
                    name="password"
                    type="password"
                    autoFocus={true}
                  />
                  <TextField
                    label="Confirm password"
                    name="confirmPassword"
                    type="password"
                  />
                  <SubmitButton
                    className="btn btn-primary"
                    value="Create your Account"
                    submittingValue="Creating .."
                  />

                  <FormError />
                </Form>
              );
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default AcceptInvite;
